import React from 'react';

import styles from './NewsFeed.module.css';

type TProps = {
  children: React.ReactNode;
};

export const NewsFeedHeader = ({ children }: TProps) => (
  <div className={styles.NewsFeed__Header}>{children}</div>
);
